export function loadFont(fontName) {
    if (!fontName) return;

    const cleanName = fontName.trim();
    const id = `font-${cleanName.replace(/\s+/g, '-').toLowerCase()}`;

    if (document.getElementById(id)) {
        return; // Already loaded
    }

    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${cleanName.replace(/\s+/g, '+')}:wght@400;700&display=swap`;

    document.head.appendChild(link);
    console.log(`🔤 Loaded font: ${cleanName}`);
}

// Attach to window for legacy/global support if needed
window.loadCustomFont = loadFont;
